import branchOffice from './service';
export default {
    branchOffice
};